import Repository from './Repository';
const resource = '/content/already-read';

export default {
  post(requestBody) {
    return Repository.post(`${resource}`, requestBody);
  }
};
